var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFocusImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 314,
    height: 183.756,
    viewBox: "0 0 314 183.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887",
    transform: "translate(-19 -196.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    transform: "translate(19 196.622)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 314,
    height: 183.756,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 310,
    height: 179.756,
    rx: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    transform: "translate(19 196.622)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 13,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 314,
    height: 183.756,
    rx: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 301,
    height: 170.756,
    rx: 12.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusImage);
export default __webpack_public_path__ + "static/media/focus-image.9703663a63bf431faece56d8f18360e8.svg";
export { ForwardRef as ReactComponent };